const IconManageFavorites = (): JSX.Element => {
  return (
    <>
      <path
        d="M2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H8L10 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V7.3C19.6833 7.16667 19.3542 7.07917 19.0125 7.0375C18.6708 6.99583 18.3333 7 18 7.05V4H9.175L7.175 2H2V14H10.1L10 14.1V16H2ZM12 18V14.925L17.525 9.425C17.675 9.275 17.8417 9.16667 18.025 9.1C18.2083 9.03333 18.3917 9 18.575 9C18.775 9 18.9667 9.0375 19.15 9.1125C19.3333 9.1875 19.5 9.3 19.65 9.45L20.575 10.375C20.7083 10.525 20.8125 10.6917 20.8875 10.875C20.9625 11.0583 21 11.2417 21 11.425C21 11.6083 20.9667 11.7958 20.9 11.9875C20.8333 12.1792 20.725 12.35 20.575 12.5L15.075 18H12ZM13.5 16.5H14.45L17.475 13.45L17.025 12.975L16.55 12.525L13.5 15.55V16.5ZM17.025 12.975L16.55 12.525L17.475 13.45L17.025 12.975Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconManageFavorites;
